module.exports = __webpack_public_path__ + "img/pura.1dfec247.jpg";